/**
 * Доступ к управлению CRM
 * @param {Object} mailAccesses
 */
export function canCrmManagement(accesses = {}) {
  return (
    accesses['contacts-types_access'] ||
    accesses['contacts-types_create'] ||
    accesses['contacts-types_update'] ||
    accesses['contacts-types_delete']
  )
}



// WEBPACK FOOTER //
// ./src/apps/crm/utils/access.js